module.exports = __webpack_public_path__ + "static/media/loadingtext1.c91adc15.svg";